import { render, staticRenderFns } from "./menuOptions.vue?vue&type=template&id=32052c7c&scoped=true"
import script from "./menuOptions.vue?vue&type=script&lang=js"
export * from "./menuOptions.vue?vue&type=script&lang=js"
import style0 from "./menuOptions.vue?vue&type=style&index=0&id=32052c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32052c7c",
  null
  
)

export default component.exports